var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.749 20.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: "0.7px",
    d: "M21.864 6.266L19.557 9.45a.642.642 0 0 1-.8.2L15.1 8.1a.616.616 0 0 1-.333-.841.63.63 0 0 1 .846-.331L18.1 7.972A8.5 8.5 0 0 0 1.305 9.756a8.484 8.484 0 0 0 14.92 5.477.655.655 0 0 1 .923-.077.645.645 0 0 1 .077.917A9.767 9.767 0 1 1 9.792 0a9.808 9.808 0 0 1 9.535 7.515l1.487-2.038a.671.671 0 0 1 .539-.281.764.764 0 0 1 .385.127.686.686 0 0 1 .127.942z",
    transform: "translate(.35 .35)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.155ee659862b0b9de3684338f69df2ac.svg";
export { ForwardRef as ReactComponent };